function carousels(backendAxiosInstance) {
  async function getCarouselInsight({ sourceCarouselId, source, type }, recommendationType, filters = {}, { max } = {}) {
    return backendAxiosInstance.get("/layouts/v4/carousels/insight", {
      includeLanguage: true,
      includeTimeZone: true,
      includeDeviceType: true,
      params: {
        sourceCarouselId,
        source,
        type,
        max,
        ...filters,
        recommendationType
      }
    });
  }
  async function getCarouselGeneral({ sourceCarouselId, source, type }, recommendationType, filters = {}, { max } = {}) {
    return backendAxiosInstance.get("/layouts/v4/carousels/general", {
      includeLanguage: true,
      includeTimeZone: true,
      includeDeviceType: true,
      params: {
        sourceCarouselId,
        source,
        type,
        max,
        ...filters,
        recommendationType
      }
    });
  }
  return {
    getCarouselGeneral,
    getCarouselInsight
  };
}

export { carousels as default };
//# sourceMappingURL=carousels.js.map
